import React, { useEffect, useState } from 'react'
import { CAMPAIGN_CREATION_STEPS } from 'types/campaign'
import './style.scss'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCampaignCreateDetails, fetchCampaignDetails } from 'slices/campaigns/details/thunk'
import { fetchCampaignRequirement } from 'slices/campaigns/requirements/thunk'
import { fetchCampaignMilestonesThunk } from 'slices/campaigns/milestones/thunk'
import Loader from 'Components/Common/Loader'

const CampaignCreationLayout: React.FC<{ children: React.ReactNode, actionRow: React.ReactNode, activeStep: string, viewOnly?: boolean }> = ({ children, actionRow, activeStep, viewOnly }) => {
    const { campaignId } = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const campaignMilestones = useSelector((state: RootState) => state.campaignMilestones.items[campaignId!]?.milestonesData?.milestones);
    const gigTypes = useSelector((state: RootState) => state.campaignMilestones.items[campaignId!]?.milestonesData?.gig_types);
    const campaignMilestone = (Array.isArray(campaignMilestones) && campaignMilestones.length > 0) ? campaignMilestones[0] : null;

    const milestoneGigType = (gigTypes ?? []).find((gigType) => gigType.id && campaignMilestone?.gig_type_id && gigType.id === campaignMilestone.gig_type_id);

    const currentStep = CAMPAIGN_CREATION_STEPS.find(step => step.key === activeStep);
    const campaignDetails = useSelector((state: RootState) => state.campaignDetails.campaigns[campaignId!]);
    const campaign = campaignDetails?.campaign;
    const campaignDetailsLoading = useSelector((state: RootState) => state.campaignDetails.loading);
    const campaignRequirementsLoading = useSelector((state: RootState) => state.campaignRequirements.loading);
    const campaignMilestonesLoading = useSelector((state: RootState) => state.campaignMilestones.loading);

    const loading = campaignDetailsLoading || campaignRequirementsLoading || campaignMilestonesLoading;

    useEffect(() => {
        if (viewOnly) return;
        if (campaignId) {
            dispatch(fetchCampaignDetails(campaignId))
            dispatch(fetchCampaignRequirement(campaignId))
            dispatch(fetchCampaignMilestonesThunk(campaignId));
        } else {
            // For campaign creation, fetch create details
            dispatch(fetchCampaignCreateDetails());
        }
    }, [campaignId, viewOnly])

    useEffect(() => {
        if (campaign && (!campaign.version || Number(campaign.version) < 2)) {
            navigate(`/campaign/${campaign.uuid}/v1/edit`);
        }
    }, [campaign])

    if (viewOnly)
        return (
            <div className="w-100 campaign-form">
                {/* Render the form for the active step here */}
                <div className="campaign-form-card mb-4">
                    {children}
                </div>
            </div>)

    return (
        <div className="page-content">
            <div className="page-content-inner page-spacing">
                <div className="d-flex justify-content-center flex-column flex-lg-row gap-4">
                    <div className="campaign-steps">
                        {
                            CAMPAIGN_CREATION_STEPS.map((step, index) => {
                                if (step.key === 'gigs' && (!milestoneGigType || milestoneGigType.slug === 'brand_promotion')) return null;

                                return (
                                    <div key={index} className={`d-flex align-items-center gap-2 justify-content-start`}>
                                        {
                                            (currentStep?.sort_order ?? 0) >= step.sort_order ? (
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#0069AD" />
                                                    <path d="M6.84617 10.0545L8.90369 11.9233L13.1427 8.07715" stroke="#FFECEC" strokeWidth="1.34615" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>

                                            ) : (
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#E0E0E0" />
                                                    <path d="M6.84617 10.0545L8.90369 11.9233L13.1427 8.07715" stroke="#AFAFAF" strokeWidth="1.34615" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            )
                                        }
                                        <div className="step-title">
                                            {
                                                campaignId ? (
                                                    <Link className='text-dark' to={{ pathname: step.url.replace('<campaignId>', campaignId!) }}>
                                                        {step.key === 'gigs' ? milestoneGigType?.object_name + 's' : step.title}
                                                    </Link>
                                                ) : (
                                                    <span className='text-dark'>
                                                        {step.key === 'gigs' ? milestoneGigType?.object_name + 's' : step.title}
                                                    </span>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    <div className="w-100 campaign-form">
                        {
                            (loading) ? (<div className="campaign-form-card mb-4">
                                <div style={{height: '370px'}} className="d-flex align-items-center justify-content-center">
                                <div className="loader"></div>
                                </div>
                            </div>)
                                : (
                                    <>
                                        {/* Render the form for the active step here */}
                                        <div className="campaign-form-card mb-4">
                                            {children}
                                        </div>
                                        {actionRow}
                                    </>
                                )
                        }

                    </div>
                </div>
            </div>
        </div>

    )
}

export default CampaignCreationLayout
